import React from 'react';
import { useReveal } from '../utils/useReveal';

const Ticker: React.FC = () => {
  const { ref, isVisible } = useReveal();
  const logos = [
    { name: 'WhatsApp', src: '/assets/whatsapp.svg' },
    { name: 'Telegram', src: '/assets/telegram.svg' },
    { name: 'Facebook', src: '/assets/facebook.svg' },
    { name: 'Instagram', src: '/assets/instagram.svg' },
    { name: 'YouTube', src: '/assets/youtube.svg' },
    { name: 'Play Store', src: '/assets/playstore.svg' },
    { name: 'App Store', src: '/assets/appstore.svg' },
    { name: 'X (Twitter)', src: '/assets/x.png' },
    { name: 'WhatsApp Business', src: '/assets/whatsapp-business.svg' },
  ];

  return (
    <>
      <style>{`
        .logo-ticker {
          width: 100%;
          overflow: hidden;
          padding: 60px 0;
          border-top: 1px solid var(--border, rgba(255, 255, 255, 0.08));
          border-bottom: 1px solid var(--border, rgba(255, 255, 255, 0.08));
          /* Ticker menggunakan tema dark sendiri */
          --bg: #0a1628;
          --text: #ffffff;
          --muted: rgba(255, 255, 255, 0.7);
          --muted-2: rgba(255, 255, 255, 0.6);
          --border: rgba(255, 255, 255, 0.08);
          --border-strong: rgba(255, 255, 255, 0.12);
          --card: rgba(255, 255, 255, 0.03);
          --card-2: rgba(255, 255, 255, 0.02);
          --chip: rgba(255, 255, 255, 0.08);
          --accent: #ffffff;
          --accent-contrast: #0a1628;
          background: var(--card-2);
          position: relative;
          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }

        .logo-ticker.revealed {
          opacity: 1;
          transform: translateY(0);
        }

        .logo-loop-wrapper {
          width: 100%;
          overflow: hidden;
          mask-image: linear-gradient(
            to right,
            transparent,
            black 20%,
            black 80%,
            transparent
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent,
            black 20%,
            black 80%,
            transparent
          );
        }

        .logo-loop-track {
          display: inline-flex;
          align-items: center;
          gap: 80px;
          animation: logo-loop 30s linear infinite;
          will-change: transform;
        }

        .ticker-logo {
          flex-shrink: 0;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: all 0.3s ease;
          padding: 8px;
          opacity: 0.7;
        }

        .ticker-logo:hover {
          transform: scale(1.2);
          opacity: 1;
        }

        .ticker-logo img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }

        .ticker-logo:hover img {
          transform: scale(1.1);
        }

        @keyframes logo-loop {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
      <div 
        className={`logo-ticker ${isVisible ? 'revealed' : ''}`}
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <div className="logo-loop-wrapper">
          <div className="logo-loop-track">
            {logos.map((logo, idx) => (
              <a key={idx} href="#" className="ticker-logo" title={logo.name}>
                <img src={logo.src} alt={logo.name} />
              </a>
            ))}
            {/* Duplicate for seamless loop */}
            {logos.map((logo, idx) => (
              <a key={`dup-${idx}`} href="#" className="ticker-logo" title={logo.name}>
                <img src={logo.src} alt={logo.name} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Ticker;

